export class UnidadesModel {
  id_unidade: number;
  id_pais: number = 0;
  nome: string;
  nome_tratamento: string;
  cnpj: string;
  cgc: string;
  serie_numero_certificado: string;
  endereco: string;
  cep: string;
  bairro: string;
  cidade: string;
  estado: string;
  telefone: string;
  responsavel: string;
  celular: string;
  site: string;
  email: string;
  sigla: string;
}



// WEBPACK FOOTER //
// ./src/app/unidades/unidades.model.ts